import type { Ref } from 'react';
import { IconChatCircleDots } from '@/components/icons/IconChatCircleDots';
import { CHAT_WIDGET_COPY } from './chat-widget.constants';

type ChatLauncherProps = {
    ref: Ref<HTMLButtonElement>;
    panelId: string;
    expanded: boolean;
    busy: boolean;
    onClick: () => void;
};

/**
 * The round chat button. `data-chatwerk-trigger` is where ChatWerk binds its own
 * open handler once it has been started.
 */
export function ChatLauncher({ ref, panelId, expanded, busy, onClick }: ChatLauncherProps) {
    return (
        <button
            ref={ref}
            type="button"
            data-chatwerk-trigger
            onClick={onClick}
            aria-label={CHAT_WIDGET_COPY.open}
            aria-expanded={expanded}
            aria-controls={expanded ? panelId : undefined}
            aria-busy={busy || undefined}
            className="inline-flex size-14 cursor-pointer items-center justify-center rounded-full bg-(--accent) text-(--accent-contrast) shadow-[0_4px_16px_rgba(var(--media-badge-bg),0.24)] transition-colors hover:bg-(--accent-hover) focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--focus-ring) aria-busy:cursor-progress aria-busy:motion-safe:animate-pulse"
        >
            <IconChatCircleDots width={28} height={28} aria-hidden="true" />
        </button>
    );
}
